import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "p-fluid p-formgrid p-grid p-m-1"
}
const _hoisted_2 = { class: "p-field p-float-label p-col-12 p-mt-2" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "p-field p-col-12 p-mt-2" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-save-new-version-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.olapSaveNewVersionDialogDescriptor.style.dialog,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.saveVersion.title')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        disabled: _ctx.loading,
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: _ctx.loading,
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock("form", _hoisted_1, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_InlineMessage, {
                  key: 0,
                  class: "p-m-1 kn-width-full",
                  severity: "info",
                  closable: "false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.saveVersion.infoMessage')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.version.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.version.name = $event)),
                modelModifiers: { trim: true }
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('documentExecution.olap.saveVersion.versionName')), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, [
                _createVNode(_component_Textarea, {
                  class: "kn-material-input",
                  modelValue: _ctx.version.descr,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.version.descr = $event)),
                  modelModifiers: { trim: true },
                  rows: "3",
                  autoResize: true
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('documentExecution.olap.saveVersion.versionDescription')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}